webpackJsonp([269829036549620],{

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -1.5rem;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -1.5rem;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding-left: 1.5rem\n\n  > h2 {\n    padding-top: 1rem;\n    border-top: 1px solid ', ';\n    font-size: 1.25rem;\n  }\n\n  @media (min-width: 32rem) {\n    width: 50%;\n  }\n'], ['\n  width: 100%;\n  padding-left: 1.5rem\n\n  > h2 {\n    padding-top: 1rem;\n    border-top: 1px solid ', ';\n    font-size: 1.25rem;\n  }\n\n  @media (min-width: 32rem) {\n    width: 50%;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _message = __webpack_require__(59);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _page = __webpack_require__(24);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _theme = __webpack_require__(16);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ServiceGrid = _styledComponents2.default.div(_templateObject);
	
	var Service = _styledComponents2.default.div(_templateObject2, _theme2.default.colors.lightTeal);
	
	var ServicesPage = function ServicesPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _page2.default,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Services Provided by ',
	        data.site.siteMetadata.title
	      )
	    ),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Creative Landscaping Services'
	    ),
	    _react2.default.createElement(
	      'p',
	      { style: { fontSize: '1.25rem' } },
	      data.site.siteMetadata.title,
	      ' offers a unique perspective on plant design and artful attention to detail. We create outdoor living spaces by uniting architecture and landscape design. We focus on creative design, quality installation and meticulously managed grounds.'
	    ),
	    _react2.default.createElement(
	      ServiceGrid,
	      null,
	      _react2.default.createElement(
	        Service,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Landscape Design'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Personal client consultation, site inspection, custom hand-drawn design plans and detailed plant specifications.'
	        )
	      ),
	      _react2.default.createElement(
	        Service,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Grounds Management'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Customized grounds management program tailored to our clients needs. Year round grounds keeping on an equal monthly payment plan or seasonal maintenance.'
	        )
	      ),
	      _react2.default.createElement(
	        Service,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Hardscape Installation'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Quality stone and brick patios, walkways, retaining walls, natural stone features, fountains, driveways and more!'
	        )
	      ),
	      _react2.default.createElement(
	        Service,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Renovation'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Landscape re-design, plant removal, specialized pruning and tree removal.'
	        )
	      ),
	      _react2.default.createElement(
	        Service,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Specialty Services'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Creative and unique pergolas, gazebos, serenity gardens, trellis and arbors, gates and fencing details.'
	        )
	      ),
	      _react2.default.createElement(
	        Service,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Irrigation & Outdoor Illumination'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Customized irrigation plans and installation to protect and display your outdoor investment.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _message2.default,
	      null,
	      'Call to schedule a free estimate ',
	      data.site.siteMetadata.phone
	    )
	  );
	};
	
	exports.default = ServicesPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-js-026a132b7611aab63c85.js